import React from 'react'

export default function LearnCrypto() {
  return (
    <div>
      <h1>Learn Crypto Here</h1>
    </div>
  )
}
